import { each, clone } from 'lodash';
import moment from 'moment';

// Given a cohort, and a numerical period
// get the proper start & end date of that period
export function getDateOfPeriod(cohort: CohortState, targetPeriod: string) {
    let foundStart = moment();
    let foundEnd = moment();
    let lastSawEndDate = moment();

    let periodIndex = 1;
    
    each(cohort.periods, period => {
        if (periodIndex === parseInt(targetPeriod)) {
            if (parseInt(targetPeriod) === 1) {
                foundEnd = moment(period.endDate);
                foundStart = null;
            }
            else {
                foundEnd = moment(period.endDate);
                foundStart = clone(lastSawEndDate);
            }
        }

        lastSawEndDate = moment(period.endDate);
        periodIndex += 1;
    });
    
    return {
        start: !!foundStart ? moment(foundStart) : null,
        end: moment(foundEnd)
    }
}
